document.addEventListener("DOMContentLoaded", () => {
  AOS.init({
    offset: 50,
    duration: 1000,
    once: true
  })
  const hamburgerBtn = document.querySelector(".header__hamburger");
  const menu = document.querySelector(".header__menu");
  const toggleMenu = () => {
    hamburgerBtn.classList.toggle("hamburger--open");
    menu.classList.toggle("menu--open");
  };
  hamburgerBtn.addEventListener("click", () => {
    toggleMenu();
  });

  //Announcement Search
  if (document.querySelector(".announcement__search")) {
    const annSearch = document.querySelector(".announcement__search");
    const categories = [...document.querySelectorAll(".announcement__search .announcement__categories span")];
    const categoryInput = document.querySelector(".announcement__search  input#category");

    const options = document.querySelectorAll(".announcement__search .announcement__inputs .announcement__select option");
    for (let category of categories) {
      category.addEventListener("click", (e) => {
        categories.forEach((element) => {
          element.classList.remove("active");
          options.forEach(option => {
            option.classList.remove('active');
          });
        });
        category.classList.add("active");
        const optionsta = document.querySelectorAll(".announcement__search .announcement__inputs .announcement__select option[cat=" + category.dataset.category + "]");
        optionsta.forEach(option => {
          option.classList.add('active');
        });
        categoryInput.value = category.dataset.category;
      });
    }
  }
  Isotope
  if (document.querySelector(".estate__cards")) {
    const cardBox = document.querySelector(".estate__cards");
    $(cardBox).isotope({
      itemSelector: ".estate__card",
      layoutMode: "masonry",
      masonry: { gutter: 20 },
      percentPosition: true,
    })

    const filterCards = (data) => {
      $(cardBox).isotope({ filter: `.${data}` })
    }

    const estateFilterButtons = [...document.querySelectorAll(".estate__controls .estate__control")]
    for (const btn of estateFilterButtons) {
      btn.addEventListener("click", () => {
        removeActiveClassFormButtons(estateFilterButtons);
        btn.classList.add("active")
        filterCards(btn.dataset.filter)

      })
      filterCards(estateFilterButtons[0].dataset.filter)
    }
  }
  const removeActiveClassFormButtons = (btns) => {
    for (const btn of btns) {
      btn.classList.remove("active")
    }
  }
  const boxes = document.querySelectorAll('.izone__box');
  if (boxes.length > 0) {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var o = url.searchParams.get("o");
    if (o != null) {
      o = parseInt(o)
      if (o <= boxes.length) {
        boxes[o - 1].querySelector('.izone__title').classList.toggle('active');
        boxes[o - 1].querySelector('.izone__files').classList.toggle('active');
      }
    }
    boxes.forEach(box => {
      box.addEventListener('click', () => {
        box.querySelector('.izone__title').classList.toggle('active');
        box.querySelector('.izone__files').classList.toggle('active');
      })
    });
  }
  const lightbox = document.createElement('div');
  lightbox.id = 'lightbox';
  document.body.appendChild(lightbox)
  const closeBtn = document.createElement('div');
  closeBtn.classList.add('lightbox__btn');
  closeBtn.innerHTML = 'x';
  lightbox.appendChild(closeBtn);
  const images = document.querySelectorAll('img.lightbox');
  images.forEach(img => {
    img.addEventListener('click', (e) => {
      lightbox.classList.add('active');
      const image = document.createElement('img');
      image.src = img.src;
      image.id = 'img';
      if (lightbox.querySelector('#img')) {
        lightbox.querySelector('#img').parentElement.removeChild(lightbox.querySelector('#img'))
      }
      lightbox.appendChild(image);
    })
  });
  lightbox.querySelector('.lightbox__btn').addEventListener('click', () => {
    lightbox.classList.remove('active')
  })
  lightbox.addEventListener('click', e => {
    if (e.target !== e.currentTarget) return
    lightbox.classList.remove('active')
  })

  $('.offer-details__slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true,
    cssEase: 'linear',
    arrows: true,
    prevArrow: '.announcements-details__arrowLeft',
    nextArrow: '.announcements-details__arrowRight',
    dots: false,
  });
  $('.announcements-details__slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true,
    cssEase: 'linear',
    arrows: true,
    prevArrow: '.announcements-details__arrowLeft',
    nextArrow: '.announcements-details__arrowRight',
    dots: false,
  });

  const btn = document.querySelector('.scrollTop');

  window.onscroll = function () { scrollFunction() };

  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  }
  if (document.querySelector('.announcements-details__left h2')) {
    const e = document.querySelector('.announcements-details__left h2');
    const b = document.querySelector('.announcements-details__left h2 span');
    b.style.height = 420 + e.offsetHeight + 'px';
  }
});

